import React, { useState } from "react";
import ButtonComponent from "../../Reusable-Components/Button-Component/ButtonComponent";
import "./SignupPageComponent.css";
import signupBackground from "../../../assests/images/signupbg.jpg";
import logo from "../../../assests/images/logov1.png";
import { graphQLCommand } from "../../../util";
import { useNavigate } from "react-router-dom";

const SignupPage = () => {
  const [userId, setUserId] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [role, setRole] = useState("User");
  const navigate = useNavigate();

  const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/;

  const handleSignup = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      alert("Passwords do not match!");
      return;
    }

    if (!emailRegex.test(email)) {
      alert("Invalid email format.");
      return;
    }

    if (!passwordRegex.test(password)) {
      alert(
        "Password must contain at least 8 characters, one uppercase letter, one lowercase letter, one number, and one special character."
      );
      return;
    }

    const query = `
      mutation {
        signup(
          id: "${userId}",
          firstName: "${firstName}",
          lastName: "${lastName}",
          email: "${email}",
          password: "${password}",
          role: "${role}"
        ) {
          id
          email
        }
      }
    `;

    try {
      const response = await graphQLCommand(query);
      console.log("Signup Successful:", response);
      navigate("/login");
    } catch (error) {
      console.error("Signup Error:", error);
      if (error.message.includes("User already exists")) {
        alert("User already exists. Redirecting to login.");
        navigate(`/login?role=${role}`);
      } else {
        alert("Signup failed. Please try again.");
      }
    }
  };

  return (
    <div className="signup-container">
      <div className="signup-form">
        <div className="logo">
          <img src={logo} alt="TOSS Logo" className="logo-image" />
        </div>
        <h2>Start Your Journey</h2>
        <p>
          Streamline turf care with efficient scheduling, monitoring, and
          resource management.
        </p>

        <form onSubmit={handleSignup}>
          <div className="form-group2">
            <label htmlFor="userId" className="labelSignup">
              User ID
            </label>
            <div className="input-wrapper">
              <input
                className="signup-input"
                type="text"
                id="userId"
                placeholder="Enter a unique User ID"
                value={userId}
                onChange={(e) => setUserId(e.target.value)}
                required
              />
            </div>
          </div>

          <div className="form-group2">
            <div className="input-wrapper">
              <label htmlFor="firstName" className="labelSignup">
                First Name
              </label>
              <input
                className="signup-input"
                type="text"
                id="firstName"
                placeholder="Enter Your First Name"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
              />
            </div></div>
            <div className="form-group2">
            <div className="input-wrapper">
              <label htmlFor="lastName" className="labelSignup">
                Last Name
              </label>
              <input
                className="signup-input2"
                type="text"
                id="lastName"
                placeholder="Enter Your Last Name"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
            </div>
          </div>

          <div className="form-group2">
            <label htmlFor="email" className="labelSignup">
              Email
            </label>
            <div className="input-wrapper">
              <input
               className="signup-input2"
                type="email"
                id="email"
                placeholder="Enter Your Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          </div>

          <div className="form-group2">
            <label htmlFor="password" className="labelSignup">
              Password
            </label>
            <div className="input-wrapper">
              <input
                type="password" className="signup-input2"
                id="password"
                placeholder="Enter Your Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>

          <div className="form-group2">
            <label htmlFor="confirmPassword" className="labelSignup">
              Confirm Password
            </label>
            <div className="input-wrapper">
              <input
                type="password"  className="signup-input2"
                id="confirmPassword"
                placeholder="Confirm Your Password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
            </div>
          </div>

          <div className="form-group2">
            <label htmlFor="role" className="labelSignup">
              Role
            </label>
            <select
              className="select-wrapper2"
              id="role"
              value={role}
              onChange={(e) => setRole(e.target.value)}
            >
              <option value="User">User</option>
              <option value="Admin">Admin</option>
              <option value="Owner">Owner</option>
            </select>
          
          </div>

          <ButtonComponent btnName={"Sign Up"} />
        </form>

        <p className="signup-text">
          Have an account? <a href="/login">Log in to get started</a>
        </p>
      </div>

      <div
        className="signup-background"
        style={{ backgroundImage: `url(${signupBackground})` }}
      >
        {/* Background Image */}
      </div>
    </div>
  );
};

export default SignupPage;
